import React, { useState, useEffect } from 'react';
import Header from '../shared/Header';
import paz from '../assets/imgs/paz.png'

import linkedin from '../assets/icns/linkedin.svg'
import whatsapp from '../assets/icns/whatsapp.svg'

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 


  return (
    <div className='container-fluid bg-light'>
      
      <div className="row mb-5">
      <div className='header-height'></div>

        <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12'>
          <div className='container'>
            <div className='row d-flex align-items-start pe-4'>
                <div className='col-12 p-4'>

                    <p className='fw-300'>
                    Effective Date: 01.02.2025
                    </p>

                    <h6>1. Introduction</h6>
                    <p className='fw-300'>
                    Welcome to Paz Roth portfolio website ("Website"). Your privacy is important, and this Privacy Policy explains how your information is collected, used, and shared when you visit this Website.
                    </p>

                    <h6>2. Information Collected</h6>
                    <p className='fw-300'>

                    This Website may collect the following types of information:
                    Personal Information: If you contact me through a contact form or email, you may provide your name, email address, and any other details you choose to share.
                    Usage Data: The Website may automatically collect data about your device, IP address, browser type, and browsing activity through cookies or analytics tools.
                    </p>

                    <h6>3. How Your Information is Used</h6>
                    <p className='fw-300'>
                    Your information may be used for the following purposes:
                    To respond to inquiries or messages you send via the contact form or email.
                    To improve the Website’s functionality and user experience.
                    To analyze traffic and usage trends using tools such as Google Analytics.
                    </p>

                    <h6>4. Sharing of Information</h6>
                    <p className='fw-300'>
                    I do not sell, trade, or rent your personal information. However, third-party services (e.g., analytics providers) may process usage data in accordance with their own privacy policies.
                    </p>

                    <h6>5. Cookies and Tracking Technologies</h6>
                    <p className='fw-300'>
                    This Website may use cookies or similar tracking technologies to enhance your experience. You can set your browser to refuse cookies, but some features may not function properly without them.
                    </p>

                    <h6>6. Data Security</h6>
                    <p className='fw-300'>
                    Reasonable measures are taken to protect your information. However, no method of transmission over the Internet is 100% secure, and I cannot guarantee absolute security.
                    </p>

                    <h6>7. Third-Party Links</h6>
                    <p className='fw-300'>
                    This Website may contain links to third-party websites. I am not responsible for the privacy practices of external sites.
                    </p>

                    <h6>8. Your Rights</h6>
                    <p className='fw-300'>
                    Depending on your location, you may have rights regarding your personal data, including the right to access, correct, or request deletion of your information.
                    </p>

                    <h6>9. Changes to this Privacy Policy</h6>
                    <p className='fw-300'>
                    I reserve the right to update this Privacy Policy. Any changes will be posted on this page with an updated effective date.
                    </p>

                    <h6>10. Contact Information</h6>
                    <p className='fw-300'>
                    If you have any questions about this Privacy Policy, please contact me at hey@pazroth.com.
                    </p>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
